import * as React from 'react';
import { useHistory } from 'react-router';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';

const AddAccessItem = () => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/accessitem`)
		.then(({ data = {} }) => {
			const { result = [] } = data;
			setFields(result);
		})
		.catch(err => {
			console.log(err);
		})
	}, []);

	const handleSubmit = values => {
		axios.post(`/api/accessitem`, values)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/accessitem');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/accessitem')
	}

	return (
		<PageContent 
			background='#fff'
			subheader={{
				title: 'Хандах эрх үүсгэх',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default AddAccessItem;